import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {Card, CardActionArea, CardContent, CardHeader, Grid} from "@mui/material";
import {useLocation} from "react-router";

type ReportEntry = {
    link:string,
    title:string,
    more:string
}

const data:ReportEntry[] = [
  { link: '/reports/campaign-financials', title: 'Campaign Financials', more: 'Campaign Financial Export for Sage Accounting' },
  { link: '/reports/job-list', title: 'Daily Job List', more: 'Distributor list for area bookings' },
  { link: '/reports/job-sheet', title: 'Weekly Job Sheet', more: 'Distributor list for panel bookings' },
  { link: '/reports/regional-revenue', title: 'Regional Revenue Report', more: 'Report of revenue by region' },
  { link: '/reports/quantities', title: 'Quantities Report', more: 'Quantities report' },
  { link: '/reports/pro-photos', title: 'Pro Photos Report', more: 'Pro photographs for the sites' },
];

data.sort((a:ReportEntry, b:ReportEntry) => {  if(a.title <b.title) return -1; if(a.title>b.title) return 1; return 0; } );

const Reports = () => {
  const navigate = useNavigate();
  const toolbarContext = useContext(ToolbarContext);
  const location= useLocation();
  const goto = (loc) => () => {
    navigate(loc);
  }
  useEffect(() => {
    toolbarContext.setPrimary(
      {
        primary: [],
        title: 'Reports',
         primaryUrl:location.pathname
      });
  }, []);

  return (
    <div className="settings is-scrollable">
        <Grid container spacing={2}>
        {
          data.map((item) => (
            <Grid key={item.link} item md={3} xs={12}>
                <Card>
                    <CardActionArea onClick={goto(item.link)}>
                        <CardHeader title={item.title} variant="h5" sx={{ paddingBottom: 0 }} />
                        <CardContent>{item.more}</CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
          ))
        }
      </Grid>
    </div>
  );
}


export default Reports;
